import hexagrams from '../data/hexagrams.json';

export function throwCoins() {
  const coins = Array.from({ length: 3 }, () => (Math.random() < 0.5 ? 3 : 2));
  return coins.reduce((a, b) => a + b, 0); // 6(노음), 7(소양), 8(소음), 9(노양)
}

export function buildHexagram() {
  const lines = Array.from({ length: 6 }, () => throwCoins());
  // 7,9 → 양효(1)  /  6,8 → 음효(0)
  const binary = lines.map(v => (v === 7 || v === 9) ? '1' : '0').join('');
  // 변효: 노음(6)→양(1), 노양(9)→음(0)
  const changingLines = lines.map((v, i) => (v === 6 || v === 9) ? i + 1 : null).filter(Boolean);
  const changedBinary = lines.map(v => {
    if (v === 6) return '1';
    if (v === 9) return '0';
    return (v === 7) ? '1' : '0';
  }).join('');

  return { lines, binary, changingLines, changedBinary };
}

export function findHexagram(binary) {
  return Object.values(hexagrams).find(h => h.binary === binary) || null;
}

export function getActiveLineText(hexagram, changingLines) {
  if (!changingLines || changingLines.length === 0) return null;
  // 첫 번째 변효의 텍스트 사용 (Phase 0)
  const pos = changingLines[0];
  const line = hexagram.lines.find(l => l.position === pos);
  return line ? `${pos}효: ${line.text}` : null;
}
